/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_CustomerGet } from '../models/Model_CustomerGet';
import type { Model_CustomerPut } from '../models/Model_CustomerPut';
import type { Model_PagedPriceListGet } from '../models/Model_PagedPriceListGet';
import type { Model_PriceListPost } from '../models/Model_PriceListPost';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomerService {
    /**
     * @param id
     * @returns Model_CustomerGet Success
     * @throws ApiError
     */
    public static getApiV1Customer(
        id: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_CustomerGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/customer/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Model_CustomerGet Success
     * @throws ApiError
     */
    public static putApiV1Customer(
        id: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_CustomerPut>,
    ): CancelablePromise<Model_CustomerGet> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/customer/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param identityId
     * @param requestBody
     * @returns Model_PagedPriceListGet Success
     * @throws ApiError
     */
    public static postApiV1CustomerPriceList(
        id: ConvertDatesToStrings<string>,
        identityId?: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_PriceListPost>,
    ): CancelablePromise<Model_PagedPriceListGet> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/customer/{id}/priceList',
            path: {
                'id': id,
            },
            query: {
                'identityId': identityId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
